import axios from 'axios'
import {
  getFileUploadGetTokenBaseUrl,
  getUsersServiceAuthBaseUrl,
  warnIfUsersServiceMissing,
} from 'utils/serviceBaseUrls'

warnIfUsersServiceMissing()

const authBase = getUsersServiceAuthBaseUrl()
export const authApi = axios.create({
  baseURL: authBase || undefined,
})

const fileTokenBase = getFileUploadGetTokenBaseUrl()
export const fileTokenApi = axios.create({
  baseURL: fileTokenBase || undefined,
})
